// Environments with reports, dashboard task search and internal/external users.
// Everywhere else the portal works as before.
const reportEnvironments = ['UK', 'GB02']

export function isReportEnvironment () {
  return reportEnvironments.includes((window.apiConfig?.ENV || '').toUpperCase())
}

// Task list columns with the Report column (green tick when a task has a report) placed before the
// short task description, as in the UK requirements mockup. Other environments get the columns unchanged.
export function withReportColumn (columns) {
  if (!isReportEnvironment() || columns.includes('Report')) {
    return columns
  }
  return insertBefore(columns, 'Report', 'TaskDescription')
}

// Task list columns with the customer before the site, as users can have several customers (UK/GB02)
export function withCustomerColumn (columns) {
  if (!isReportEnvironment() || columns.includes('Customer')) {
    return columns
  }
  return insertBefore(columns, 'Customer', 'Object1')
}

// All the UK/GB02 task list columns: Report and Customer
export function withUkTaskColumns (columns) {
  return withCustomerColumn(withReportColumn(columns))
}

function insertBefore (columns, column, before) {
  const index = columns.indexOf(before)
  const result = [...columns]
  result.splice(index === -1 ? result.length : index, 0, column)
  return result
}
